module.exports = __webpack_public_path__ + "static/media/baby.e8279755.png";